var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('order-list',{attrs:{"orders":_vm.orders,"isShowPagination":_vm.total,"order-type":Number(_vm.type)}})}
var staticRenderFns = []

export { render, staticRenderFns }